/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeleteUserPaymentMethod200ResponseAllOfData } from './DeleteUserPaymentMethod200ResponseAllOfData';
import {
    DeleteUserPaymentMethod200ResponseAllOfDataFromJSON,
    DeleteUserPaymentMethod200ResponseAllOfDataFromJSONTyped,
    DeleteUserPaymentMethod200ResponseAllOfDataToJSON,
} from './DeleteUserPaymentMethod200ResponseAllOfData';

/**
 * 
 * @export
 * @interface DeleteUserPaymentMethod200ResponseAllOf
 */
export interface DeleteUserPaymentMethod200ResponseAllOf {
    /**
     * 
     * @type {DeleteUserPaymentMethod200ResponseAllOfData}
     * @memberof DeleteUserPaymentMethod200ResponseAllOf
     */
    data?: DeleteUserPaymentMethod200ResponseAllOfData;
}

/**
 * Check if a given object implements the DeleteUserPaymentMethod200ResponseAllOf interface.
 */
export function instanceOfDeleteUserPaymentMethod200ResponseAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DeleteUserPaymentMethod200ResponseAllOfFromJSON(json: any): DeleteUserPaymentMethod200ResponseAllOf {
    return DeleteUserPaymentMethod200ResponseAllOfFromJSONTyped(json, false);
}

export function DeleteUserPaymentMethod200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteUserPaymentMethod200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : DeleteUserPaymentMethod200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function DeleteUserPaymentMethod200ResponseAllOfToJSON(value?: DeleteUserPaymentMethod200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': DeleteUserPaymentMethod200ResponseAllOfDataToJSON(value.data),
    };
}

